import styled from 'styled-components';
import { Container } from 'reactstrap';

export const TextBody = styled.div`
  font-size: 0.875rem;
  p {
    margin-bottom: .6rem;
  }
`;

export const AboutDfsContainer = styled(Container)`
  @media(max-width: 576px) {
    padding: 0;
  }
`
